import * as React from 'react';
import '../../../panels/panels.css';
import { Button, Label, Segment, Form, Checkbox, Dropdown, Input, Radio } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import OAuth, { OAuthClientStatus } from '../../../api';

class State {
    hssVodCont: boolean; hssStreamIdReq: boolean; hssRedirectManifest: boolean; hssShareConn: boolean; hssPersistConn: boolean;
    hssManifestGzip: boolean; hssMediaGetIvl: any; hssAutoStartComp: string; hssAutoStartCompAllVideo: boolean;
    hssAutoStartCompAllAudio: boolean; hssAutoStartCompAllText: boolean; hssAutoStartCompLimitVideo: boolean; hssAutoStartCompLimitAudio: boolean;
    hssAutoStartCompLimitText:	boolean; hssAutoStartCompLimitVideoVar: string; hssAutoStartCompLimitAudioVar: string; hssAutoStartCompLimitTextVar: any;
    hssVarNameOptPatternMatch: boolean; hssMediaFileStartPos: any; hssCookieMode: boolean; hssDecrypt: boolean; hssPersistConnTimeout: any;
}

interface Props {

}

export default class MicrosoftStreamConfig extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            hssVodCont: false, hssStreamIdReq: false, hssRedirectManifest: false, hssShareConn: false, hssPersistConn: false,
            hssManifestGzip: false, hssMediaGetIvl: '', hssAutoStartComp: '', hssAutoStartCompAllVideo: false,
            hssAutoStartCompAllAudio: false, hssAutoStartCompAllText: false, hssAutoStartCompLimitVideo: false, hssAutoStartCompLimitAudio: false,
            hssAutoStartCompLimitText: false, hssAutoStartCompLimitVideoVar: '', hssAutoStartCompLimitAudioVar: '', hssAutoStartCompLimitTextVar: '',
            hssVarNameOptPatternMatch: false, hssMediaFileStartPos: '', hssCookieMode: false, hssDecrypt: false, hssPersistConnTimeout: 0,
        });

        this.fetchData();
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options: [
                'hssVodCont', 'hssStreamIdReq', 'hssRedirectManifest', 'hssShareConn', 'hssPersistConn', 'hssManifestGzip', 'hssMediaGetIvl',
                'hssAutoStartComp', 'hssAutoStartCompAllVideo', 'hssAutoStartCompAllAudio', 'hssAutoStartCompLimitVideo',
                'hssAutoStartCompLimitAudio', 'hssAutoStartCompLimitVideoVar', 'hssAutoStartCompLimitAudioVar',
                'hssVarNameOptPatternMatch', 'hssMediaFileStartPos', 'hssAutoStartCompAllText', 'hssAutoStartCompLimitText', 'hssAutoStartCompLimitTextVar',
                'hssCookieMode', 'hssDecrypt', 'hssPersistConnTimeout'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;

                    _this.setState({
                        hssVodCont: responseObject[0].value, hssStreamIdReq: responseObject[1].value, hssRedirectManifest: responseObject[2].value,
                        hssShareConn: responseObject[3].value, hssPersistConn: responseObject[4].value, hssManifestGzip: responseObject[5].value,
                        hssMediaGetIvl: responseObject[6].value,  hssAutoStartComp: responseObject[7].value,
                        hssAutoStartCompAllVideo: responseObject[8].value, hssAutoStartCompAllAudio: responseObject[9].value,
                        hssAutoStartCompLimitVideo: responseObject[10].value, hssAutoStartCompLimitAudio: responseObject[11].value,
                        hssAutoStartCompLimitVideoVar: responseObject[12].value, hssAutoStartCompLimitAudioVar: responseObject[13].value,
                        hssVarNameOptPatternMatch: responseObject[14].value, hssMediaFileStartPos: responseObject[15].value,
                        hssAutoStartCompAllText: responseObject[16].value, hssAutoStartCompLimitText: responseObject[17].value,
                        hssAutoStartCompLimitTextVar: responseObject[18].value, hssCookieMode: responseObject[19].value, hssDecrypt: responseObject[20].value,
                        hssPersistConnTimeout: responseObject[21].value,
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });

    }

    updateConfig(e: any, data: any) {
        //    let _this = this;
        let url = 'http://default/api/config/section/options/abr';

        axios.post(url, {
            mode: 'modify',
            defaults: {
            },
            options: [
                { 'name': 'hssVodCont', 'value': this.state.hssVodCont },
                { 'name': 'hssStreamIdReq', 'value': this.state.hssStreamIdReq },
                { 'name': 'hssRedirectManifest', 'value': this.state.hssRedirectManifest },
                { 'name': 'hssShareConn', 'value': this.state.hssShareConn },
                { 'name': 'hssPersistConn', 'value': this.state.hssPersistConn },
                { 'name': 'hssManifestGzip', 'value': this.state.hssManifestGzip },
                { 'name': 'hssMediaGetIvl', 'value': this.state.hssMediaGetIvl },
                { 'name': 'hssAutoStartComp', 'value': this.state.hssAutoStartComp },
                { 'name': 'hssAutoStartCompAllVideo', 'value': this.state.hssAutoStartCompAllVideo },
                { 'name': 'hssAutoStartCompAllAudio', 'value': this.state.hssAutoStartCompAllAudio },
                { 'name': 'hssAutoStartCompLimitVideo', 'value': this.state.hssAutoStartCompLimitVideo },
                { 'name': 'hssAutoStartCompLimitAudio', 'value': this.state.hssAutoStartCompLimitAudio },
                { 'name': 'hssAutoStartCompLimitVideoVar', 'value': this.state.hssAutoStartCompLimitVideoVar },
                { 'name': 'hssAutoStartCompLimitAudioVar', 'value': this.state.hssAutoStartCompLimitAudioVar },
                { 'name': 'hssVarNameOptPatternMatch', 'value': this.state.hssVarNameOptPatternMatch },
                { 'name': 'hssMediaFileStartPos', 'value': this.state.hssMediaFileStartPos },
                { 'name': 'hssAutoStartCompAllText', 'value': this.state.hssAutoStartCompAllText},
                { 'name': 'hssAutoStartCompLimitText', 'value': this.state.hssAutoStartCompLimitText},
                { 'name': 'hssAutoStartCompLimitTextVar', 'value': this.state.hssAutoStartCompLimitTextVar},
                { 'name': 'hssCookieMode', 'value': this.state.hssCookieMode },
                { 'name': 'hssDecrypt', 'value': this.state.hssDecrypt },
                { 'name': 'hssPersistConnTimeout', 'value': this.state.hssPersistConnTimeout},
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('Microsoft / Smooth Streaming configuration applied');
                } else {
                    Toast.error('Microsoft / Smooth Streaming configuration failed');
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('updateConfig() error: ', error);
                Toast.error('Microsoft / Smooth Streaming configuration failed');
            });
    }

    render() {
        const mediaFileReqOptions = [
            { value: 25, text: '25'},
            { value: 50, text: '50'},
            { value: 100, text: '100'}
        ];
        const mediaFileStartPosOptions = [
            { value: 'auto', text: 'Auto' },
            { value: 'begin', text: 'Begin' },
            { value: 'end', text: 'End' }
        ];
        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    return (
                        <React.Fragment>
                            <div className="assetAliasFilters">
                                <Label className="system-config-pageHeader">
                                    Microsoft/Smooth Streaming
                                </Label>
                                <Button
                                    floated="right"
                                    className="rightButton"
                                    content="Apply"
                                    title="Update Config"
                                    onClick={(e, data) => this.updateConfig(e, data)}
                                />
                            </div>
                            <div className="vertical-flex-main">
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">Streaming Options</Segment>
                                <Segment>
                                    <Form>
                                        {!oauth.VODOnlyLicensePresent ?
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Play VOD Streams Continuously
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hssVodCont}
                                                onChange={(e: any, data: any) => this.setState({hssVodCont: data.checked})}
                                            />
                                        </Form.Group>
                                        : null}
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Include Stream Identifier Cookie In HTTP Requests
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hssStreamIdReq}
                                                onChange={(e: any, data: any) => this.setState({hssStreamIdReq: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Manifest Redirect
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hssRedirectManifest}
                                                onChange={(e: any, data: any) => this.setState({hssRedirectManifest: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Shared Manifest/Media Connections
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hssShareConn}
                                                onChange={(e: any, data: any) => this.setState({hssShareConn: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped style={{display: 'flex', alignItems: 'center'}}>
                                            <Label className="right-align-label-width500">
                                                Enable Persistent Connections
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hssPersistConn}
                                                onChange={(e: any, data: any) => this.setState({hssPersistConn: data.checked})}
                                            />
                                            {/*<Dropdown*/}
                                            {/*    className="dropDown"*/}
                                            {/*    search*/}
                                            {/*    value={this.state.hssMediaGetIvl}*/}
                                            {/*    options={mediaFileReqOptions}*/}
                                            {/*    selection*/}
                                            {/*    onChange={(event, data) => this.setState({hssMediaGetIvl: data.value})}*/}
                                            {/*/>*/}
                                            <Label className={!this.state.hssPersistConn ? 'right-align-label-width170 label-disabled' : 'right-align-label-width170'}>
                                                Timeout (seconds)
                                            </Label>
                                            <Input
                                                className="small-input"
                                                disabled={!this.state.hssPersistConn}
                                                type="number"
                                                min="0"
                                                max="600"
                                                value={this.state.hssPersistConnTimeout}
                                                onChange={(e: any, data: any) => this.setState({hssPersistConnTimeout: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Decryption
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hssDecrypt}
                                                onChange={(e: any, data: any) => this.setState({hssDecrypt: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Cookies
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hssCookieMode}
                                                onChange={(e: any, data: any) => this.setState({hssCookieMode: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Manifest GZIP Compression
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hssManifestGzip}
                                                onChange={(e: any, data: any) => this.setState({hssManifestGzip: data.checked})}
                                            />
                                        </Form.Group>
                                        {!oauth.VODOnlyLicensePresent ?
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Maximum Media File Requests Per Manifest File Request
                                            </Label>
                                            <Dropdown
                                                className="dropDown"
                                                search
                                                value={this.state.hssMediaGetIvl}
                                                options={mediaFileReqOptions}
                                                selection
                                                onChange={(event, data) => this.setState({hssMediaGetIvl: data.value})}
                                            />
                                        </Form.Group>
                                        : null}
                                        {!oauth.VODOnlyLicensePresent ?
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Media File Start Position
                                            </Label>
                                            <Dropdown
                                                search
                                                value={this.state.hssMediaFileStartPos}
                                                options={mediaFileStartPosOptions}
                                                selection
                                                onChange={(event, data) => this.setState({hssMediaFileStartPos: data.value})}
                                            />
                                        </Form.Group>
                                        : null}
                                    </Form>
                                </Segment>
                            </Segment.Group>
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">Variant Name Options
                                    <Label className="right-align-label-width"  style={{ width: 347 }}>
                                        Pattern Match
                                    </Label>
                                    <Checkbox
                                        className="config-checkbox"
                                        checked={this.state.hssVarNameOptPatternMatch}
                                        onChange={(e: any, data: any) => this.setState({hssVarNameOptPatternMatch: data.checked})}
                                    />
                                </Segment>
                                <Segment className="segment-header">Auto-Start Variant Streams</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Disable
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="disabled"
                                                checked={this.state.hssAutoStartComp === 'disabled'}
                                                onChange={(e: any, data: any) => this.setState({hssAutoStartComp: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                All
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="all"
                                                checked={this.state.hssAutoStartComp === 'all'}
                                                onChange={(e: any, data: any) => this.setState({hssAutoStartComp: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hssAutoStartComp !== 'all')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Video
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hssAutoStartComp !== 'all'}
                                                className="config-checkbox"
                                                checked={this.state.hssAutoStartCompAllVideo}
                                                onChange={(e: any, data: any) => this.setState({hssAutoStartCompAllVideo: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hssAutoStartComp !== 'all')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Audio
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hssAutoStartComp !== 'all'}
                                                className="config-checkbox"
                                                checked={this.state.hssAutoStartCompAllAudio}
                                                onChange={(e: any, data: any) => this.setState({hssAutoStartCompAllAudio: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hssAutoStartComp !== 'all')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Text Track
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hssAutoStartComp !== 'all'}
                                                className="config-checkbox"
                                                checked={this.state.hssAutoStartCompAllText}
                                                onChange={(e: any, data: any) => this.setState({hssAutoStartCompAllText: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Limited
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="limited"
                                                checked={this.state.hssAutoStartComp === 'limited'}
                                                onChange={(e: any, data: any) => this.setState({hssAutoStartComp: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hssAutoStartComp !== 'limited')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Video Variants
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hssAutoStartComp !== 'limited'}
                                                className="config-checkbox"
                                                checked={this.state.hssAutoStartCompLimitVideo}
                                                onChange={(e: any, data: any) => this.setState({hssAutoStartCompLimitVideo: data.checked})}
                                            />
                                            <Input
                                                disabled={((this.state.hssAutoStartComp !== 'limited') || (!this.state.hssAutoStartCompLimitVideo))}
                                                className="small-input-leftMargin"
                                                value={this.state.hssAutoStartCompLimitVideoVar}
                                                onChange={(e: any, data: any) => this.setState({hssAutoStartCompLimitVideoVar: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hssAutoStartComp !== 'limited')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Audio Variants
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hssAutoStartComp !== 'limited'}
                                                maxLength={63}
                                                className="config-checkbox"
                                                checked={this.state.hssAutoStartCompLimitAudio}
                                                onChange={(e: any, data: any) => this.setState({hssAutoStartCompLimitAudio: data.checked})}
                                            />
                                            <Input
                                                disabled={((this.state.hssAutoStartComp !== 'limited') || (!this.state.hssAutoStartCompLimitAudio))}
                                                maxLength={63}
                                                className="small-input-leftMargin"
                                                value={this.state.hssAutoStartCompLimitAudioVar}
                                                onChange={(e: any, data: any) => this.setState({hssAutoStartCompLimitAudioVar: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hssAutoStartComp !== 'limited')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Text Track Variants
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hssAutoStartComp !== 'limited'}
                                                maxLength={63}
                                                className="config-checkbox"
                                                checked={this.state.hssAutoStartCompLimitText}
                                                onChange={(e: any, data: any) => this.setState({hssAutoStartCompLimitText: data.checked})}
                                            />
                                            <Input
                                                disabled={((this.state.hssAutoStartComp !== 'limited') || (!this.state.hssAutoStartCompLimitText))}
                                                maxLength={63}
                                                className="small-input-leftMargin"
                                                value={this.state.hssAutoStartCompLimitTextVar}
                                                onChange={(e: any, data: any) => this.setState({hssAutoStartCompLimitTextVar: data.value})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                            </div>
                        </React.Fragment>
                    );
                }}
            </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/microsoftStreamConfig.tsx